export enum MenuCodeEnum {
  /**
   * 首页-菜单
   */
  home = 'home',
  /**
   * 首页-按钮: DRO挂牌列表
   */
  homeDROList = 'home:DROList',
  /**
   * 首页-按钮: ETP挂牌列表
   */
  homeETPList = 'home:ETPList',
  /**
   * 首页-按钮: IO挂牌列表
   */
  homeIOList = 'home:IOList',
  /**
   * 首页-按钮: AO挂牌列表
   */
  homeAOList = 'home:AOList',
  /**
   * 首页-按钮: SO挂牌列表
   */
  homeSOList = 'home:SOList',
  /**
   * 首页-按钮: 指数走势
   */
  homeTrend = 'home:trend',
  /**
   * 首页-按钮: 最新资讯列表
   */
  homeNews = 'home:news',
  /**
   * 首页-按钮: 发行成功分布图
   */
  homeDistribution = 'home:distribution',
  /**
   * 首页-按钮: 自选
   */
  homeOption = 'home:option',
  /**
   * 首页-按钮: 取消自选
   */
  homeOptionCancel = 'home:optionCancel',
  /**
   * 首页-按钮: DRO详情
   */
  homeDRODetail = 'home:droDetail',
  /**
   * 首页-按钮: 资讯详情
   */
  homeNewsDetail = 'home:newsDetail',
  /**
   * 交易-菜单
   */
  trading = 'trading',
  /**
   * 交易-首次发行产品列表
   */
  tradingDroList = 'trading:dro:IOList',
  /**
   * 交易-首次发行产品列表-批量申购
   */
  tradingBatchPurchase = 'trading:dro:IOList:IOPurchase',
  /**
   * 交易-按钮: IO挂牌列表
   */
  tradingIOList = 'trading:IOList',
  /**
   * 交易-按钮: AO挂牌列表
   */
  tradingAOList = 'trading:AOList',
  /**
   * 交易-按钮: SO挂牌列表
   */
  tradingSOList = 'trading:SOList',
  /**
   *  交易-DRO: 二级交易
   */
  tradingDroSoList = 'trading:dro:SOList',
  /**
   * 交易-按钮: 筛选模块
   */
  tradingFilter = 'trading:filter',
  /**
   * 交易-按钮: DRO详情
   */
  tradingDRODetail = 'trading:droDetail',
  /**
   * 查看资产明细-按钮
   */
  assetDetail = 'trading:assetDetail',
  /**
   * 交易-按钮: 自选
   */
  tradingOption = 'trading:option',
  /**
   * 交易-按钮: 取消自选
   */
  tradingOptionCancel = 'trading:optionCancel',
  /**
   * 交易-按钮: AO申购
   */
  tradingAOPurchase = 'trading:AOPurchase',
  /**
   * 交易-按钮: SO买入
   */
  tradingSOPurchase = 'trading:SOPurchase',
  /**
   * 自选-菜单
   */
  option = 'option',
  /**
   * 自选-dro列表
   */
  optionDroList = 'option:dro:IOList',
  /**
   * 自选-按钮: IO挂牌
   */
  optionIOList = 'option:IOList',
  /**
   * 自选-按钮: AO挂牌
   */
  optionAOList = 'option:AOList',
  /**
   * 自选-按钮: AO申购
   */
  optionAOPurchase = 'option:AOPurchase',
  /**
   * 自选-按钮: SO挂牌
   */
  optionSOList = 'option:SOList',

  /**
   * 自选-DRO: 二级交易
   */
  optionDroSoList = 'option:dro:SOList',
  /**
   * 自选-按钮: 筛选模块
   */
  optionFilter = 'option:filter',
  /**
   * 自选-按钮: DRO详情
   */
  optionDRODetail = 'option:droDetail',
  /**
   * 自选-按钮: SO买入
   */
  optionSOPurchase = 'option:SOPurchase',
  /**
   * 自选-按钮: 取消自选
   */
  optionCancel = 'option:cancel',
  /**
   * 持仓-菜单
   */
  position = 'position',
  /**
   * 持仓-按钮: DRP
   */
  positionDRP = 'position:drpDetail',
  /**
   * 持仓-按钮: 收益分配
   */
  positionIncome = 'position:income',
  /**
   * 持仓-按钮: 组合分布图
   */
  positionDistribution = 'position:distribution',
  /**
   * 持仓-按钮: 现金流表现图
   */
  positionIncomeFlow = 'position:incomeFlow',
  /**
   * 持仓-按钮: DRO
   */
  positionDRO = 'position:dro',
  /**
   * 持仓-按钮: DRO 收益分配
   */
  positionDROIncome = 'position:dro:income',
  /**
   * 持仓-按钮: ETP
   */
  positionETP = 'position:etp',
  /**
   * 资金-菜单
   */
  fund = 'fund',
  /**
   * 资金-按钮: 资金充值
   */
  fundRecharge = 'fund:recharge',
  /**
   * 资金-按钮: 资金提取
   */
  fundWithdraw = 'fund:withdraw',
  /**
   * 资金-按钮: 操作记录
   */
  fundRecord = 'fund:record',
  /**
   * 资金-按钮: 交易资金分配
   */
  fundTransfer = 'fund:transfer',
  /**
   * 委托-菜单
   */
  agency = 'agency',
  /**
   * 委托-dro列表
   */
  agencyDroList = 'agency:dro:IOList',
  /**
   * 委托-dro列表-撤单
   */
  agencyDroListCancel = 'agency:dro:cancel',
  /**
   * 委托-按钮: 撤单
   */
  agencyCancel = 'agency:cancel',
  /**
   * 委托-按钮: IO挂牌
   */
  agencyIOList = 'agency:IOList',
  /**
   * 委托-按钮: AO挂牌
   */
  agencyAOList = 'agency:AOList',
  /**
   * 委托-按钮: SO挂牌
   */
  agencySOList = 'agency:SOList',
  /**
   * 委托-DRO: 二级交易
   */
  agencyDroSoList = 'agency:dro:SOList',
  /**
   * 委托-DRO: 做市确认
   */
  agencyDroMarketMaking = 'agency:dro:marketMaking',
  /**
   * 会员-菜单
   */
  userMgr = 'userMgr',
  /**
   * 会员-用户管理-菜单
   */
  userMgrUser = 'userMgr:user',
  /**
   * 会员-用户管理-按钮: 新增用户
   */
  userMgrUserCreate = 'userMgr:user:userCreate',
  /**
   * 会员-用户管理-按钮: 变更角色
   */
  userMgrUserChangeRole = 'userMgr:user:changeRole',
  /**
   * 会员-用户管理-按钮: 注销用户
   */
  userMgrUserLogOff = 'userMgr:user:cancel',
  /**
   * 会员-用户管理-按钮: 移交超管
   */
  userMgrUserTransfer = 'userMgr:user:transferAdmin',
  /**
   * 会员-用户管理-按钮: 查看权限
   */
  userMgrViewUserPermission = 'userMgr:user:viewPermission',
  /**
   * 会员-角色管理
   */
  userMgrRole = 'userMgr:role',
  /**
   * 会员-角色管理-按钮: 新增角色
   */
  userMgrRoleCreate = 'userMgr:role:roleCreate',
  /**
   * 会员-角色管理-按钮: 修改角色权限
   */
  userMgrRoleChangePermission = 'userMgr:role:changePermission',
  /**
   * 会员-角色管理-按钮: 删除角色
   */
  userMgrRoleDelete = 'userMgr:role:delete',
  /**
   * 会员-角色管理-按钮: 查看角色详情
   */
  userMgrRoleViewDetail = 'userMgr:role:viewDetail',
  /**
   * 会员-会员信息-菜单
   */
  userMgrInfo = 'userMgr:info',
  /**
   * 会员-会员信息-菜单: 修改资料
   */
  userMgrInfoModification = 'userMgr:info:modification',
  /**
   * 会员-账户管理-菜单
   */
  userMgrAccMgr = 'userMgr:accountManagement',
  /**
   * 会员-账户管理-tab: 交易账户
   */
  userMgrAccMgrTrading = 'userMgr:accountManagement:trading',
  /**
   * 会员-账户管理-交易账户-列表
   */
  userMgrAccMgrTradingList = 'userMgr:accountManagement:trading:list',
  /**
   * 会员-账户管理-交易账户-按钮: 新增
   */
  userMgrAccMgrTradingCreate = 'userMgr:accountManagement:trading:tradingCreate',
  /**
   * 会员-账户管理-tab: 结算账户
   */
  userMgrAccMgrSettlement = 'userMgr:accountManagement:settlement',
  /**
   * 会员-账户管理-结算账户-列表
   */
  userMgrAccMgrSettlementList = 'userMgr:accountManagement:settlement:list',
  /**
   * 会员-账户管理-结算账户-按钮: 新增
   */
  userMgrAccMgrSettlementCreate = 'userMgr:accountManagement:settlement:settlementCreate',
  /**
   * 会员-账户管理-结算账户-按钮: 注销
   */
  userMgrAccMgrSettlementLogOff = 'userMgr:accountManagement:settlement:settlementCancel',
  /**
   * 会员-账户管理-tab: 专业投资者
   */
  userMgrAccMgrProfessional = 'userMgr:accountManagement:professional',
  /**
   * 会员-账户管理-专业投资者-列表
   */
  userMgrAccMgrProfessionalList = 'userMgr:accountManagement:professional:list',
  /**
   * 会员-账户管理-专业投资者-按钮: 新增
   */
  userMgrAccMgrProfessionalCreate = 'userMgr:accountManagement:professional:professionalCreate',
  /**
   * 通用IO挂牌
   */
  IOList = 'IOList',
  /**
   * 通用SO挂牌
   */
  SOList = 'SOList',
  /**
   * 用户信息
   */
  userInfo = 'userInfo',
  /**
   * 用户信息-修改头像-按钮
   */
  editUserProfile = 'userInfo:editUserProfile',
  /**
   * 用户信息-修改姓氏-按钮
   */
  editFirstName = 'userInfo:editFirstName',
  /**
   * 用户信息-修改名称-按钮
   */
  editLastName = 'userInfo:editLastName',
  /**
   * 用户信息-修改密码-按钮
   */
  editPassword = 'userInfo:editPassword',
  /**
   * 结单-菜单
   */
  settlement = 'settlement',
  /**
   * 结单-按钮: 下载
   */
  settlementDownload = 'settlement:download',

  /** ***********************- DMP权限 -***********************/
  /**
   * DMP权限: 持仓列表-菜单
   */
  dmpPositionList = 'dmp:positionList',
  /**
   * DMP权限: 持仓列表-按钮: 导出
   */
  dmpPositionListExport = 'dmp:positionList:export',
  /**
   * DMP权限: 持仓列表-菜单: DRO详情
   */
  dmpPositionListDroDetail = 'dmp:positionList:droDetail',

  /**
   * DMP权限: 质押记录-菜单
   */
  dmpPledgeRecord = 'dmp:pledgeRecord',
  /**
   * DMP权限: 质押记录-按钮: 导出
   */
  dmpPledgeRecordExport = 'dmp:pledgeRecord:export',

  /**
   * DMP权限: 出售记录-菜单
   */
  dmpSellRecord = 'dmp:sellRecord',
  /**
   * DMP权限: 出售记录-按钮: 导出
   */
  dmpSellRecordExport = 'dmp:sellRecord:export',

  /**
   * DMP权限: 封包记录-菜单
   */
  dmpPackageRecord = 'dmp:packageRecord',
  /**
   * DMP权限: 封包记录-按钮: 导出
   */
  dmpPackageRecordExport = 'dmp:packageRecord:export',
  /**
   * DMP权限: 封包记录-按钮: 封包
   */
  dmpPackageRecordPackage = 'dmp:packageRecord:package',
  /**
   * DMP权限: 封包记录-按钮: 批量解包
   */
  dmpPackageRecordBatchUnpack = 'dmp:packageRecord:batchUnpack',

  /**
   * DMP权限: 资金流水-菜单
   */
  dmpFundFlow = 'dmp:fundFlow',
  /**
   * DMP权限: 资金流水-按钮: 导出
   */
  dmpFundFlowExport = 'dmp:fundFlow:export',

  // 系统通知
  sysNotification = 'notification',
  // 系统通知-消息列表
  sysNotificationList = 'notification:info',
  // 系统通知-文件列表
  sysNotificationFile = 'notification:file',

  /** DRO详情 */
  droDetail = 'droDetail',
  /** DRO详情-Tab: 投研 */
  droDetailResearch = 'droDetail:investResearch',
  /** DRO详情-投研-按钮: 估值试算 */
  droDetailValuation = 'droDetail:investResearch:estimation',
  /** DRO详情-投研-按钮: 下载PCF */
  droDetailDownloadPCF = 'droDetail:investResearch:downloadPCF',
}
